import { Checkbox, DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBulkUpdatesConfirmation extends Layout {
    checkboxAssociatePayAdjustments: Checkbox;
    checkboxConfirmVoid: Checkbox;
    sourceSettlement: DataSource;
    textboxComment: Textbox;
    textboxReasonCode: Textbox;
    textboxStatus: Textbox;
}
